<template>
  <Layout>
    <div class="banner-page">
      <img :src="'/img/program-banner.jpg'" alt="Image" />
    </div>

    <div class="breadcrumbs">
      <div class="container">
        <ul>
          <li>
            <router-link to="/">Beranda</router-link>
          </li>
          <li>
            <span>Program</span>
          </li>
        </ul>
      </div>
    </div>

    <section class="page-section">
      <div class="container">
        <div class="section-title text-center">Infaq Masjed</div>
        <div class="text-center mb-32">
          Berikan Donasi terbaikmu, untuk masjed di sekitarmu.
        </div>

        <!-- <div v-if="this.isLoading == true" style="display: flex; justify-content: center; align-items: center;">Memuat...</div> -->
        <div>
          <div class="maps-wrapper">
            <div class="maps-filter">
              <GmapAutocomplete
                @place_changed="setPlace"
                class="form-control"
                placeholder="Cari Masjed disini..."
              />
              <!-- <button @click="addMarker" class="btn btn-main btn-filter">
                Cari
              </button> -->
            </div>
            <div class="maps-overlay" v-if="isLoading">
              <div class="memuat">Memuat...</div>
            </div>
            <GmapMap
              :center="centerr"
              :zoom="15"
              style="width: 100%; height: 400px"
            >
              <GmapMarker
                :key="index"
                v-for="(m, index) in markers"
                :position="m.position"
                :icon="icons"
                @click="test(m.position)"
              />
              <GmapMarker
                :key="index + Math.random()"
                v-for="(m, index) in markerss"
                :position="m.position"
              />
            </GmapMap>
          </div>
        </div>
      </div>
    </section>
    <simple-modal v-model="isShow" :title="namaMasjid">
      <template slot="body">
        <div>
          {{ alamatMasjid }}
        </div>
        <div
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 16px;
          "
        >
          <button
            type="button"
            @click="setMasjidId"
            class="btn btn-main"
          >
            <div>Donasi Sekarang</div>
          </button>
        </div>
      </template>
    </simple-modal>
  </Layout>
</template>

<script>
import axios from 'axios';
import Layout from '../views/layouts/Index.vue';
// import json from '../assets/json/maps.json';
// import $ from 'jquery';
import SimpleModal from 'simple-modal-vue';
import { mapActions } from 'vuex';

export default {
  components: {
    Layout,
    SimpleModal,
  },
  data() {
    return {
      isShow: false,
      center: { lat: 45.508, lng: -73.587 },
      centerr: { lat: 45.508, lng: -73.587 },
      currentPlace: null,
      markers: [],
      markerss: [],
      places: [],
      placess: [],
      lat: null,
      lng: null,
      list: null,
      icons: {
        url: 'https://maps.gstatic.com/mapfiles/place_api/icons/v1/png_71/worship_islam-71.png',
        scaledSize: { width: 28, height: 28 },
        labelOrigin: { x: 16, y: -10 },
      },
      iconss: {
        url: 'https://image.flaticon.com/teams/slug/google.jpg',
        scaledSize: { width: 28, height: 28 },
        labelOrigin: { x: 16, y: -10 },
      },
      image: [],
      mylatlng: null,
      currentPlacenew: null,
      currentPlaceneww: null,
      idMasjid: '',
      namaMasjid: '',
      alamatMasjid: '',
      isLoading: false,
    };
  },
  methods: {
    ...mapActions('transactions', ['setIdmasjid', 'resetForm']),
    setMasjidId() {
      this.setIdmasjid(this.idMasjid);
      // this.$router.push({ name: 'donasi-masjed-pembayaran' });
      location.href = '/donasi-masjed-pembayaran';
    },
    test: function (data) {
      // console.log(data);
      // let element = this.$refs.modal.$el
      this.isShow = true;
      this.idMasjid = data.id;
      this.namaMasjid = data.nama_masjid;
      this.alamatMasjid = data.alamat_masjid;
    },
    goToDonasi: function () {
      localStorage.setItem('idmasjid', localStorage.getItem('id'));
      this.$router.push('/donasi-masjed');
    },
    setPlace: function (place) {
      // console.log(place.geometry.location.lat())
      const hello = {
        geometry: {
          location: {
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng(),
          },
        },
      };
      this.currentPlace = hello;
      this.addMarker();
    },
    addMarker: function () {
      if (this.currentPlace) {
        if (this.marker) {
          // console.log(this.markerss.length)
          this.markerss.shift();
        }
        this.marker = {
          lat: this.currentPlace.geometry.location.lat,
          lng: this.currentPlace.geometry.location.lng,
        };

        this.markerss.push({ position: this.marker });
        this.placess.push(this.currentPlace);
        this.centerr = this.marker;
        // this.currentPlace = null;
      }

      // console.log(this.marker);
    },
    geolocate: function () {
      navigator.geolocation.getCurrentPosition((position) => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
        this.currentPlace = {
          geometry: {
            location: {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            },
          },
        };

        this.addMarker();
        this.getAllPositionMarker();
        this.isLoading = true;
      });
    },
    getAllPositionMarker: function () {
      // console.log(json.list)

      axios
        .get(
          'https://masjed.id/app/apis/front/getlatlng?lat=-6.256245&lng=106.82906179999999'
        )
        .then((response) => {
          // console.log(response);
          this.list = response.data.list;

          this.list.forEach((element) => {
            // console.log(element);
            this.currentPlacenew = {
              id: element.id,
              lat: parseFloat(element.lat),
              lng: parseFloat(element.lng),
              nama_masjid: element.nama_masjid,
              alamat_masjid: element.alamat_masjid,
            };

            this.currentPlaceneww = {
              geometry: {
                location: {
                  id: element.id,
                  lat: parseFloat(element.lat),
                  lng: parseFloat(element.lng),
                  nama_masjid: element.nama_masjid,
                  alamat_masjid: element.alamat_masjid,
                },
              },
            };

            this.markers.push({
              position: this.currentPlacenew,
            });
            this.places.push(this.currentPlaceneww);
            this.center = this.currentPlacenew;
            this.currentPlaceneww = null;
            this.isLoading = false;
          });
        })
        .finally((this.isLoading = false));
    },
  },
  mounted() {
    this.geolocate();
    this.resetForm();
  },
};
</script>

<style lang="scss" scoped>
.maps-wrapper {
  position: relative;

  @media screen and (max-width: 480px) {
    margin-top: 80px;
  }
  .maps-filter {
    position: absolute;
    width: 50vh;
    z-index: 99;
    left: 0;
    right: 0;
    margin: 0 auto;
    // border: 1px solid black;
    top: 10px;

    @media screen and (max-width: 480px) {
      width: 100%;
      top: -50px;
    }
    .form-control {
      width: 30vh !important;
      display: inline-block;
      height: 40px;
      border-radius: 20px;
      padding-left: 16px;
      margin-right: 4px;
      margin-left: 4px;

      @media screen and (max-width: 480px) {
        width: 100% !important;
        // margin-right: 15px;
        border-radius: 20px;
        // margin-left: 5px;
        border: 1px solid #ccc;
        height: 40px;
      }
    }
  }
  .maps-overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    display: block;
    background: rgba($color: #000000, $alpha: 0.5);
    z-index: 100;
    .memuat {
      color: white;
      font-size: 2vh;
      position: relative;
      top: 50%;
      text-align: center;
    }
  }
}
</style>
